export const menuItem = [
  {
    title: "classes",
    path: '/classes'
  },
  {
    title: "zubroteka",
    path: '/zubroteka',
  },
  {
    title: "workshops",
    path: '/workshops',
  },
  // {
  //   title: "Contentcreator",
  //   path: '/Content-creator',
  // },
];
export const AdminmenuItem = [
  {
    title: "userlist",
    path: '/userlist'
  },
  {
    title: "classlist",
    path: '/classlist'

  },
  {
    title: "parentslist",
    path: '/parentslist'
  },
  {
    title: "teacherlist",
    path: '/teacherlist'
  },
  {
    title: "creatorList",
    path: '/creatorList'
  },

];

export const classes = [
  {
    id: 1,
    thumbnail: "/assets/images/class1.png",
    name: "Aštuntokai",
    studentscount: 30,
    teacherscount: 2,
    backgroundcolor: "#D5FAE5",
  },
  {
    id: 2,
    thumbnail: "/assets/images/class2.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#EEEFFF",
  },
  {
    id: 3,
    thumbnail: "/assets/images/class3.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#FFECDE",
  },
  {
    id: 4,
    thumbnail: "/assets/images/class4.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#FFEDEF",
  },
  {
    id: 5,
    thumbnail: "/assets/images/class5.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#D5FAE5",
  },
  {
    id: 6,
    thumbnail: "/assets/images/class6.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#EAECFF",
  },
  {
    id: 7,
    thumbnail: "/assets/images/class7.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#FFF8DE",
  },
  {
    id: 8,
    thumbnail: "/assets/images/class8.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#EEEFFF",
  },
  {
    id: 9,
    thumbnail: "/assets/images/class9.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#D5FAE5",
  },
  {
    id: 10,
    thumbnail: "/assets/images/class10.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#FFF8DE",
  },
  {
    id: 11,
    thumbnail: "/assets/images/class11.png",
    name: "Devintokai",
    studentscount: 0,
    teacherscount: 1,
    backgroundcolor: "#EAECFF",
  },
];
export const classestab = [
  {
    tab: "overview",
  },
  {
    tab: "material",
  },
  {
    tab: "people",
  },
];

export const overviewdata = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 600 },
];
export const COLORS = ["#1E4AD9", "#FF4F62", "#FFBB28", "#FF8042"];

export const activityData = [
  {
    name: "Adas Maknys",
    val: 12,
    percentage: "12%",
    img: "",
  },
  {
    name: "Kajus Cicinskas",
    val: 5,
    percentage: "12%",
    img: "",
  },
  {
    name: "Jonė Kaminskaitė",
    val: 12,
    percentage: "12%",
    img: "",
  },
  {
    name: "Adas Maknys",
    val: 6,
    percentage: "12%",
    img: "",
  },
  {
    name: "Liuka Vaikytė",
    val: 1,
    percentage: "12%",
    img: "",
  },
];

export const subjects = [
  {
    id: 1,
    img: "/assets/images/History.png",
    text: "Šiluminiai reiškiniai",
    questioncount: 43,
  },
  {
    id: 2,
    img: "/assets/images/Geography.png",
    text: "Judėjimas ir jėgos fizika",
    questioncount: 33,
  },
  {
    id: 3,
    img: "/assets/images/Physics.png",
    text: "Pasaulio politinis žemėlapis ir valstybių ekonominės galios skirtumai",
    questioncount: 67,
  },
  {
    id: 4,
    img: "/assets/images/earth.png",
    text: "Lietuvos ir pasaulio gyventojai",
    questioncount: 32,
  },
];
export const peoples = [
  {
    id: 1,
    img: "/assets/images/people.png",
    name: "Lina Kaikarienė (Jūs)",
    Statistika: false,
    questioncount: 43,
  },
  {
    id: 2,
    img: "/assets/images/people2.png",
    name: "Roma Vaišienė",
    questioncount: 33,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: false,
  },
  {
    id: 3,
    img: "/assets/images/Physics.png",
    name: "Rytis Bulėnas",
    questioncount: 67,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: true,
  },
  {
    id: 4,
    img: "/assets/images/earth.png",
    name: "Kajus Cicinskas",
    questioncount: 32,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: true,
  },
  {
    id: 1,
    img: "/assets/images/people.png",
    name: "Lina Kaikarienė (Jūs)",
    Statistika: false,
    questioncount: 43,
  },
  {
    id: 2,
    img: "/assets/images/people2.png",
    name: "Roma Vaišienė",
    questioncount: 33,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: false,
  },
  {
    id: 3,
    img: "/assets/images/Physics.png",
    name: "Rytis Bulėnas",
    questioncount: 67,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: true,
  },
  {
    id: 4,
    img: "/assets/images/earth.png",
    name: "Kajus Cicinskas",
    questioncount: 32,
    teacher: "Mokytoja",
    subject: "Biologija",
    Statistika: true,
  },
];
export const whatnext = [
  {
    title: "Pridėkite klausimus",
    desc: "Pridėkite klausimus su atsakymais, įterpkite mediją ir suflerius.",
  },
  {
    title: "Sukurkite pavadinimą",
    desc: "Geras ir suprantamas pavadinimas pritrauks daugiau naudotojų",
  },
  {
    title: "Parinkite nustatymus",
    desc: "Priskirkite kategoriją, amžiaus cenzą ir kitus parametrus.",
  },
  {
    title: "Stebėkite statistiką",
    desc: "Žiūrėkite kiek naudotojų pritraukėte, bei kurie klausimai sulaukia daugiausiai dėmesio",
  },
  {
    title: "Gaukite atsiliepimus",
    desc: "Gaukite atsiliepimus iš naudotojų ir tobulinkite savo kaladę",
  },
];

export const backgroundColors = [
  "#FFE5E5", "#FFE5EC", "#F8E8FF", "#E5E5FF", "#E5F0FF", "#E5FFED", "#FFFFE5",
  "#FFF0E5", "#FFE5F8", "#E5FFE8", "#E5FFF0", "#E5FFF8", "#F0F0F0"
];
